(() => {
  const defaults = {
    customization: 'Your customization', measurements: 'Measurements', shortEdit: 'Edit',
    savedView: 'Saved · View measurements', savedHide: 'Saved · Hide measurements',
    optional: 'Optional', add: 'Add', notAdded: 'Not added', nameEmbroidery: 'Name embroidery',
    completeDetails: 'Complete details', thread: 'thread', logo: 'Logo', uploadNeeded: 'Upload needed',
    customLogo: 'Custom logo', fee: 'Customization', embroideryEdit: 'Edit embroidery and logo',
    embroideryAdd: 'Add embroidery and logo', embroideryTitle: 'Embroidery and Logo',
    confirmEmbroidery: 'Confirm customization', closeEmbroidery: 'Close customization',
    chooseColor: 'Please choose an embroidery color.', enterText: 'Please enter the text to embroider.',
    uploadLogo: 'Please upload your logo and wait for the upload to finish.'
  };
  function summarizeEmbroidery(fields, labels = defaults) {
    const parts = [];
    if (fields.embroidery === 'Yes, add embroidery') {
      parts.push(fields.text || labels.nameEmbroidery);
      if (fields.color) parts.push(`${fields.color} ${labels.thread}`);
      if (!fields.text || !fields.color) parts.push(labels.completeDetails);
    }
    if (fields.logo === 'Yes, add custom logo') {
      parts.push(fields.upload ? labels.customLogo : `${labels.logo} · ${labels.uploadNeeded}`);
    }
    const selected = Boolean(fields.embroidery || fields.logo);
    return {summary: parts.join(' · ') || (selected ? labels.notAdded : labels.optional), action: selected ? labels.shortEdit : labels.add, selected};
  }
  function parseCustomizationFee(value) {
    const match = value.trim().match(/^Selections will add\s+(.+?)\s+to the product single price$/i);
    if (!match) return null;
    const digits = match[1].replace(/\D/g, '');
    return digits && /^0+$/.test(digits) ? '' : match[1];
  }
  function missingEmbroideryField(fields) {
    if (fields.embroidery === 'Yes, add embroidery') {
      if (!fields.color?.trim()) return 'color';
      if (!fields.text?.trim()) return 'text';
    }
    if (fields.logo === 'Yes, add custom logo' && !fields.upload?.trim()) return 'upload';
    return null;
  }
  if (typeof window === 'undefined') {
    if (typeof module !== 'undefined') module.exports = {summarizeEmbroidery, parseCustomizationFee, missingEmbroideryField};
    return;
  }
  if (window.wcfCustomCleanInstalled) return;
  window.wcfCustomCleanInstalled = true;
  const setClass = (el, name, enabled) => { if (el.classList.contains(name) !== enabled) el.classList.toggle(name, enabled); };
  const text = (el, value) => { if (el.textContent !== value) el.textContent = value; };
  const embroideryDialogs = new WeakMap();
  const activeDialogStates = new Set();
  let embroideryDialogId = 0;
  function embroideryFields(accordion) {
    const selected = name => accordion.querySelector(`input[name="expo[${name}]"]:checked`)?.value || '';
    const value = name => accordion.querySelector(`[name="expo[${name}]"]`)?.value.trim() || '';
    return {embroidery:selected('Embroidery'), logo:selected('Custom Logo'), color:selected('Embroidery Color'), text:value('Embroidery Text'), upload:value('Upload Your Logo')};
  }
  function syncDialogScrollLock() {
    activeDialogStates.forEach(state => {
      if (!state.accordion.isConnected || !state.dialog.isConnected) {
        if (state.dialog.open) state.dialog.close();
        activeDialogStates.delete(state); embroideryDialogs.delete(state.accordion);
      }
    });
    setClass(document.documentElement, 'wcf-embroidery-modal-open', [...activeDialogStates].some(state => state.dialog.open));
  }
  function enhanceEmbroideryDialog(accordion, labels) {
    if (accordion.classList.contains('wcf-embroidery-steps')) return;
    if (typeof HTMLDialogElement === 'undefined') return;
    let state = embroideryDialogs.get(accordion);
    const trigger = accordion.querySelector('.expo-accordion__trigger');
    const body = accordion.querySelector('.expo-accordion__content-body');
    if (!trigger || !body) return;
    if (!state) {
      const dialog = document.createElement('dialog'); dialog.className = 'wcf-embroidery-dialog';
      const titleId = `wcf-embroidery-dialog-title-${++embroideryDialogId}`;
      const header = document.createElement('div'); header.className = 'wcf-embroidery-dialog__header';
      const title = document.createElement('h2'); title.id = titleId; title.textContent = labels.embroideryTitle;
      const close = document.createElement('button'); close.type = 'button'; close.dataset.wcfEmbroideryClose = ''; close.setAttribute('aria-label', labels.closeEmbroidery); close.textContent = '×';
      header.append(title, close);
      const footer = document.createElement('div'); footer.className = 'wcf-embroidery-dialog__footer';
      const error = document.createElement('p'); error.className = 'wcf-embroidery-dialog__error'; error.setAttribute('role', 'alert'); error.hidden = true;
      const confirm = document.createElement('button'); confirm.type = 'button'; confirm.dataset.wcfEmbroideryConfirm = ''; confirm.textContent = labels.confirmEmbroidery;
      footer.append(error, confirm);
      dialog.setAttribute('aria-labelledby', titleId);
      body.parentElement.insertBefore(dialog, body); dialog.append(header, body, footer);
      state = {accordion, dialog, body, trigger, error};
      embroideryDialogs.set(accordion, state); activeDialogStates.add(state);
      setClass(accordion, 'wcf-embroidery-modal-ready', true);
      trigger.setAttribute('aria-haspopup', 'dialog');
      const closeDialog = () => {
        closeTooltips();
        if (dialog.open) dialog.close();
        if (trigger.getAttribute('aria-expanded') === 'true') trigger.click();
        syncDialogScrollLock();
        if (trigger.isConnected) trigger.focus({preventScroll:true});
      };
      close.addEventListener('click', closeDialog);
      dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(); });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog();
      });
      confirm.addEventListener('click', () => {
        const missing = missingEmbroideryField(embroideryFields(accordion));
        if (missing) {
          const messages = {color:labels.chooseColor, text:labels.enterText, upload:labels.uploadLogo};
          text(error, messages[missing]); error.hidden = false;
          const selectors = {color:'[name="expo[Embroidery Color]"]', text:'[name="expo[Embroidery Text]"]', upload:'input[type="file"]'};
          const control = body.querySelector(selectors[missing]);
          const wrapper = control?.closest('.expo-element-wrapper'); wrapper?.scrollIntoView({block:'nearest'});
          if (control?.getClientRects().length) control.focus({preventScroll:true});
          return;
        }
        const invalid = [...body.querySelectorAll('input,select,textarea')].find(control => control.willValidate && !control.checkValidity());
        if (invalid) { text(error, invalid.validationMessage); error.hidden = false; invalid.focus(); return; }
        error.hidden = true; closeDialog();
      });
      body.addEventListener('input', () => { if (!error.hidden) error.hidden = true; });
      body.addEventListener('change', () => { if (!error.hidden) error.hidden = true; });
      body.addEventListener('invalid', event => {
        event.preventDefault();
        if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
        text(error, event.target.validationMessage); error.hidden = false;
        requestAnimationFrame(() => event.target.focus());
      }, true);
    }
    const expanded = trigger.getAttribute('aria-expanded') === 'true';
    if (expanded && !state.dialog.open) {
      state.error.hidden = true; state.dialog.showModal();
    } else if (!expanded && state.dialog.open) {
      closeTooltips(); state.dialog.close();
    }
  }
  function enhanceEmbroiderySteps(scope, labels) {
    if (document.querySelector('product-info[data-wcf-personalize-preview]')) return;
    scope.querySelectorAll('.expo-set-wrapper').forEach(wrapper => {
      let state = embroideryDialogs.get(wrapper);
      const steps = state?.steps || wrapper.querySelector(':scope > .expo-steps');
      if (!steps || !steps.querySelector('[name="expo[Embroidery]"]') || !steps.querySelector('[name="expo[Custom Logo]"]')) return;
      if (typeof HTMLDialogElement === 'undefined') return;
      if (!state) {
        const trigger = document.createElement('button'); trigger.type = 'button';
        trigger.className = 'expo-accordion__trigger wcf-embroidery-step-trigger';
        const titleText = document.createElement('span'); titleText.textContent = labels.embroideryTitle; trigger.append(titleText);
        const dialog = document.createElement('dialog'); dialog.className = 'wcf-embroidery-dialog wcf-embroidery-step-dialog';
        dialog.id = `wcf-embroidery-steps-${++embroideryDialogId}`;
        const header = document.createElement('div'); header.className = 'wcf-embroidery-dialog__header';
        const title = document.createElement('h2'); title.id = `${dialog.id}-title`; title.textContent = labels.embroideryTitle;
        const close = document.createElement('button'); close.type = 'button'; close.dataset.wcfEmbroideryClose = ''; close.textContent = '×'; close.setAttribute('aria-label', labels.closeEmbroidery);
        header.append(title, close);
        const body = document.createElement('div'); body.className = 'wcf-embroidery-steps-body';
        dialog.append(header, body); dialog.setAttribute('aria-labelledby', title.id);
        trigger.setAttribute('aria-controls', dialog.id); trigger.setAttribute('aria-haspopup', 'dialog'); trigger.setAttribute('aria-expanded', 'false');
        wrapper.insertBefore(trigger, steps); wrapper.insertBefore(dialog, steps); body.append(steps);
        wrapper.classList.add('wcf-embroidery-accordion', 'wcf-embroidery-modal-ready', 'wcf-embroidery-steps');
        state = {accordion:wrapper, dialog, body, trigger, steps, opening:false};
        const closeDialog = () => {
          closeTooltips(); if (dialog.open) dialog.close();
          trigger.setAttribute('aria-expanded', 'false'); syncDialogScrollLock();
          if (trigger.isConnected) trigger.focus({preventScroll:true});
        };
        state.close = closeDialog;
        state.open = async (restart = true) => {
          if (state.opening || dialog.open) return;
          state.opening = true;
          try {
            // Use the app's own Back controls to leave Review and return to step one.
            if (restart) for (let attempts = 0; attempts <= steps.querySelectorAll('.expo-step-panel').length; attempts++) {
              const back = steps.querySelector('.expo-steps-back');
              if (!back || back.disabled || !steps.isConnected) break;
              back.click(); await new Promise(resolve => requestAnimationFrame(resolve));
            }
            if (!dialog.isConnected) return;
            body.scrollTop = 0; dialog.showModal(); trigger.setAttribute('aria-expanded', 'true'); syncDialogScrollLock();
          } finally { state.opening = false; }
        };
        state.reveal = async target => {
          if (state.revealing) return;
          const targetPanel = target.closest('.expo-step-panel');
          if (!targetPanel) return;
          state.revealing = true;
          try {
            await state.open();
            const panels = [...steps.querySelectorAll('.expo-step-panel')];
            const targetIndex = panels.indexOf(targetPanel);
            for (let attempt = 0; targetIndex >= 0 && attempt <= panels.length; attempt++) {
              const currentIndex = panels.findIndex(panel => getComputedStyle(panel).display !== 'none');
              if (currentIndex === targetIndex) break;
              const button = steps.querySelector(currentIndex > targetIndex ? '.expo-steps-back' : '.expo-steps-next');
              if (!button || button.disabled) break;
              button.click(); await new Promise(resolve => requestAnimationFrame(resolve));
              if (panels.findIndex(panel => getComputedStyle(panel).display !== 'none') === currentIndex) break;
            }
            if (target.isConnected && getComputedStyle(targetPanel).display !== 'none') {
              target.classList.remove('hidden'); target.scrollIntoView({block:'nearest', behavior:'instant'});
              // Focus the message, not an empty input: its blur validator can resize
              // the centered dialog during the user's next click.
              target.tabIndex = -1; target.focus({preventScroll:true});
            }
          } finally { state.revealing = false; }
        };
        trigger.addEventListener('click', () => state.open());
        close.addEventListener('click', closeDialog);
        dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(); });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const r = dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) closeDialog();
        });
        steps.addEventListener('click', event => {
          if (event.target.closest('.expo-steps-next,.expo-steps-back,.expo-steps-done')) {
            const activeBefore = [...steps.querySelectorAll('.expo-step-panel')].find(panel => getComputedStyle(panel).display !== 'none');
            closeTooltips(); requestAnimationFrame(() => {
              const activeAfter = [...steps.querySelectorAll('.expo-step-panel')].find(panel => getComputedStyle(panel).display !== 'none');
              if (activeBefore !== activeAfter) body.scrollTop = 0;
            });
          }
        });
        embroideryDialogs.set(wrapper, state); activeDialogStates.add(state);
      }
      const doneLabel = steps.querySelector('.expo-steps-done > span');
      if (doneLabel) text(doneLabel, labels.confirmEmbroidery);
      // The native app only creates Review after its final-step validation succeeds.
      if (state.dialog.open && !state.opening && steps.querySelector('.expo-steps-review')) state.close();
    });
  }
  const tooltipBindings = new WeakSet();
  let tooltipId = 0;
  function setTooltip(icon, open) {
    setClass(icon, 'wcf-tooltip-open', open);
    if (icon.getAttribute('aria-expanded') !== String(open)) icon.setAttribute('aria-expanded', String(open));
  }
  function closeTooltips(except) {
    document.querySelectorAll('.wcf-custom-clean .wcf-tooltip-open').forEach(icon => { if (icon !== except) setTooltip(icon, false); });
  }
  function enhanceTooltips(scope) {
    scope.querySelectorAll('.wcf-embroidery-accordion .expo-tooltip-icon').forEach(icon => {
      const tooltip = icon.querySelector('.expo-tooltip');
      if (!tooltip || tooltipBindings.has(icon)) return;
      tooltipBindings.add(icon);
      if (!tooltip.id) tooltip.id = `wcf-field-tooltip-${++tooltipId}`;
      tooltip.setAttribute('role', 'tooltip');
      icon.setAttribute('role', 'button'); icon.tabIndex = 0;
      icon.setAttribute('aria-label', icon.closest('.expo-element-label')?.firstElementChild?.textContent.trim() || '?');
      icon.setAttribute('aria-describedby', tooltip.id); icon.setAttribute('aria-expanded', 'false');
      const toggle = event => {
        event.preventDefault(); event.stopPropagation();
        const open = !icon.classList.contains('wcf-tooltip-open');
        closeTooltips(icon); setTooltip(icon, open);
      };
      icon.addEventListener('click', toggle);
      icon.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') toggle(event); });
      icon.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { closeTooltips(icon); setTooltip(icon, true); } });
      icon.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') setTooltip(icon, false); });
      icon.addEventListener('blur', () => setTooltip(icon, false));
    });
    scope.querySelectorAll('.wcf-embroidery-accordion .expo-accordion__content:not(.is-open) .wcf-tooltip-open').forEach(icon => setTooltip(icon, false));
  }
  function enhance(scope) {
    const config = scope.querySelector('[data-wcf-clean-labels]');
    if (!config) return;
    let labels; try { labels = {...defaults, ...JSON.parse(config.textContent)}; } catch { return; }
    enhanceEmbroiderySteps(scope, labels);
    scope.querySelectorAll('.expo-steps-trigger-wrap').forEach(wrap => {
      const trigger = wrap.querySelector('.expo-steps-trigger');
      if (!trigger) return;
      let heading = wrap.querySelector('.wcf-clean-measure-heading');
      if (!heading) {
        heading = document.createElement('div'); heading.className = 'wcf-clean-measure-heading';
        const title = document.createElement('strong'); title.textContent = labels.title;
        heading.append(title); wrap.prepend(heading);
      }
      const saved = wrap.classList.contains('wcf-has-measurement-summary');
      text(heading.querySelector('strong'), saved ? labels.customization : labels.title);
      text(trigger, saved ? labels.shortEdit : labels.enter);
      const accessibleLabel = saved ? labels.edit : labels.enter;
      if (trigger.getAttribute('aria-label') !== accessibleLabel) trigger.setAttribute('aria-label', accessibleLabel);
      let rowTitle = wrap.querySelector('.wcf-clean-measure-title');
      if (!rowTitle) { rowTitle = document.createElement('strong'); rowTitle.className = 'wcf-clean-measure-title'; wrap.append(rowTitle); }
      text(rowTitle, labels.measurements);
      if (rowTitle.hidden !== !saved) rowTitle.hidden = !saved;
      const toggle = wrap.querySelector('.wcf-measurements-summary-toggle');
      if (toggle) text(toggle, toggle.getAttribute('aria-expanded') === 'true' ? labels.savedHide : labels.savedView);
    });
    scope.querySelectorAll('.wcf-embroidery-accordion').forEach(accordion => {
      const trigger = accordion.querySelector('.expo-accordion__trigger');
      if (!trigger) return;
      const result = summarizeEmbroidery(embroideryFields(accordion), labels);
      setClass(accordion, 'wcf-embroidery-has-selection', result.selected);
      let summary = trigger.querySelector('.wcf-clean-embroidery-summary');
      let action = trigger.querySelector('.wcf-clean-embroidery-action');
      if (!summary) { summary=document.createElement('span'); summary.className='wcf-clean-embroidery-summary'; trigger.append(summary); }
      if (!action) { action=document.createElement('span'); action.className='wcf-clean-embroidery-action'; trigger.append(action); }
      text(summary, result.summary); text(action, result.action);
      const ariaLabel = result.selected ? labels.embroideryEdit : labels.embroideryAdd;
      if (trigger.getAttribute('aria-label') !== ariaLabel) trigger.setAttribute('aria-label', ariaLabel);
      enhanceEmbroideryDialog(accordion, labels);
    });
    enhanceTooltips(scope);
    scope.querySelectorAll('fieldset').forEach(fieldset => {
      const inputs = [...fieldset.querySelectorAll('input[data-option-name="Number of Sets"]')];
      if (!inputs.length) return;
      setClass(fieldset, 'wcf-clean-sets', true);
      inputs.forEach(input => {
        const label = [...fieldset.querySelectorAll('label')].find(label => label.htmlFor === input.id);
        if (!label || !/^\d+$/.test(input.value)) return;
        const value = `${input.value} ${input.value === '1' ? labels.set : labels.sets}`;
        const node = [...label.childNodes].find(n => n.nodeType === Node.TEXT_NODE);
        if (node && node.nodeValue.trim() !== value) node.nodeValue = value;
      });
    });
    scope.querySelectorAll('.expo-extra-subtotal').forEach(el => {
      const source = [...el.childNodes].filter(node => !node.classList?.contains('wcf-clean-fee')).map(node => node.textContent).join('');
      const amount = parseCustomizationFee(source);
      setClass(el, 'wcf-clean-zero-fee', amount === '');
      setClass(el, 'wcf-clean-fee-ready', amount !== null);
      let row = el.querySelector('.wcf-clean-fee');
      if (amount === null) { if (row) row.remove(); return; }
      if (!row) { row=document.createElement('div'); row.className='wcf-clean-fee'; row.append(document.createElement('span'), document.createElement('strong')); el.append(row); }
      text(row.firstElementChild, labels.fee);
      text(row.lastElementChild, amount ? `+${amount}` : '');
    });
  }
  let scheduled = false;
  const scan = () => { scheduled = false; syncDialogScrollLock(); document.querySelectorAll('product-info.wcf-custom-clean').forEach(enhance); syncDialogScrollLock(); };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(scan); } };
  new MutationObserver(schedule).observe(document.documentElement, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['class', 'aria-expanded']});
  document.addEventListener('input', schedule); document.addEventListener('change', schedule); document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('click', event => { if (!event.target.closest?.('.wcf-custom-clean .expo-tooltip-icon')) closeTooltips(); });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeTooltips(); });
  window.addEventListener('expo:validation-failed', event => {
    const selectors = event.detail?.selectors;
    if (!Array.isArray(selectors)) return;
    for (const state of activeDialogStates) {
      if (!state.steps?.isConnected || !state.reveal) continue;
      for (const selector of selectors) {
        if (typeof selector !== 'string') continue;
        let target; try { target = document.querySelector(selector); } catch { continue; }
        if (target && state.steps.contains(target)) { void state.reveal(target); return; }
      }
    }
  });
  scan();
})();
